import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogAction,
  AlertDialogCancel,
} from "@jourfx/ui";

type PrivacyNoticeModalProps = {
  open: boolean;
  title: string;
  body: string;
  acceptLabel: string;
  declineLabel: string;
  onAccept: () => void;
  onDecline: () => void;
};

export function PrivacyNoticeModal({
  open,
  title,
  body,
  acceptLabel,
  declineLabel,
  onAccept,
  onDecline,
}: PrivacyNoticeModalProps) {
  return (
    <AlertDialog open={open}>
      <AlertDialogContent className="max-w-xl gap-0 overflow-hidden rounded-2xl border-[var(--stone-100)] bg-white p-0 shadow-2xl">
        <AlertDialogHeader className="border-b border-[var(--stone-100)] px-6 py-5 text-left">
          <AlertDialogTitle className="text-2xl font-semibold text-[var(--stone-800)]">
            {title}
          </AlertDialogTitle>
          <AlertDialogDescription className="mt-3 text-base leading-relaxed text-[var(--stone-600)]">
            {body}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="border-t border-[var(--stone-100)] px-6 py-4 sm:justify-end">
          <AlertDialogCancel
            onClick={onDecline}
            className="mt-0 h-12 rounded-xl border-[var(--stone-200)] text-[var(--stone-700)] hover:bg-[var(--stone-50)] hover:text-[var(--stone-800)]"
          >
            {declineLabel}
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={onAccept}
            className="h-12 rounded-xl border-0 bg-[var(--sage-600)] text-white hover:bg-[var(--sage-700)]"
          >
            {acceptLabel}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
